import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { DateTime } from 'luxon';

@Entity()
export class AttendanceOverviewResult extends AdornisEntity {
  public static override _class = 'AttendanceOverviewResult';

  @Field(() => DateTime)
  public lastAttendance: Maybe<DateTime>;

  @Field(() => Int)
  public attendanceCount: Maybe<number>;
}
